<template lang='pug' src='./custom-home-icons.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { showModal } from 'components/mixins'

export default {
  props: ['props'],
  mixins: [showModal],
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-icons.vue?4ebc76a3